<!-- App.svelte -->
<script>
  import { Router, Route } from "svelte-routing";

  import Index from "./pages/Index.svelte";
  import Results from "./pages/Results.svelte";
  import Profiling from "./pages/Profiling.svelte";
  import Questionnaire from "./pages/Questionnaire.svelte";

  export let url = "";
</script>

<Router url="{url}">
  <Route path="results/:id" component="{Results}" />
  <Route path="p/:id" component="{Profiling}" />
  <Route path="q" component="{Questionnaire}" />
  <Route path="/" component="{Index}" />
</Router>
